import React, {useState} from 'react';
import {View, Text, StyleSheet} from 'react-native';
import Layout from '../../components/Layout';
import TitleBlock from '../../components/TitleBlock';
import Themes from '../../themes';
import FormPAT from '../../form/FormPAT';

const SimuPAT = ({navigation}) => {
  const [valeurDF, setValeurDF] = useState(0);
  const [valeurDP, setValeurDP] = useState(0);
  const [valeurCAC, setValeurCAC] = useState(0);
  const [valeurCHC, setValeurCHC] = useState(0);
  const [valeurTVLLP, setValeurTVLLP] = useState(0);
  const [valeurTA, setValeurTA] = useState(0);
  const [result, setResult] = useState(0);

  const form = (
    <View style={[styles.scene]}>
      <FormPAT
        setValeurDF={setValeurDF}
        setValeurDP={setValeurDP}
        setValeurCAC={setValeurCAC}
        setValeurCHC={setValeurCHC}
        setValeurTVLLP={setValeurTVLLP}
        setValeurTA={setValeurTA}
        setResult={setResult}
      />
    </View>
  );

  const results = (
    <View style={styles.scene}>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>
          MONTANT CENTIMES ADDITIONNELS COMMUNAUX (CAC)
        </Text>
        <Text style={[styles.result]}>{valeurCAC}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>
          MONTANT TAXE SUR LA VALEUR LOCATIVE DES LOCAUX PROFESSIONNELS (TVLLP)
        </Text>
        <Text style={[styles.result]}>{valeurTVLLP}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>
          MONTANT CHAMBRE DE COMMERCE (CHC / CCISM)
        </Text>
        <Text style={[styles.result]}>{valeurCHC}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>MONTANT TAXE APPRENTISSAGE</Text>
        <Text style={[styles.result]}>{valeurTA}</Text>
      </View>
      <View style={[styles.resultItem]}>
        <Text style={[styles.label]}>MONTANT TOTAL PATENTE</Text>
        <Text style={[styles.result]}>{result}</Text>
      </View>
    </View>
  );

  return (
    <Layout>
      <TitleBlock
        bgColor={Themes.colors.lightPurple}
        textColor="white"
        image={require('../../assets/home-icon-home.png')}>
        Simulation de la patente
      </TitleBlock>
      {form}
      {results}
    </Layout>
  );
};

const styles = StyleSheet.create({
  scene: {
    flex: 1,
    padding: 20,
  },
  resultItem: {
    flexDirection: 'row',
    paddingVertical: 3,
    borderBottomWidth: 3,
    borderBottomColor: Themes.colors.lightBlue,
    borderStyle: 'dashed',
    justifyContent: 'center',
    alignItems: 'center',
  },
  label: {
    flex: 1,
    flexGrow: 2,
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: Themes.colors.lightBlue,
  },
  result: {
    flex: 1,
    fontFamily: 'Roboto-Bold',
    fontSize: 18,
    color: Themes.colors.lightBlue,
    textAlign: 'right',
  },
});

export default SimuPAT;
